import { useApolloClient } from '@apollo/client'
import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  CreateDocumentsDocument,
  CreateDocumentsMutation,
  CreateDocumentsMutationVariables,
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateDocuments = () => {
  const client = useApolloClient()
  const [createDocuments, { loading }] = useMutation(CreateDocumentsDocument, {
    extractorFn: (data: CreateDocumentsMutation) =>
      data.documentsMutations.bulkCreateDocumentsDocument,
  })

  return {
    loading,
    async createDocuments(variables: CreateDocumentsMutationVariables) {
      const result = await createDocuments({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [DocumentsDocument, DocumentsDataTableDocument],
      })

      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useCreateDocuments
